import { Inbox } from "lucide-react";
import type { ReactNode } from "react";

/**
 * Honest "no data" panel. Use this whenever a chart/table would otherwise
 * render zero rows or an axis without points. Always explain WHY the data
 * is missing (no AE2 attribute, no tariff source, tenant permissions) and
 * what would make it populate.
 */
export function EmptyState({
  title,
  detail,
  icon,
  action,
  height = 240,
}: {
  title: string;
  detail?: string;
  icon?: ReactNode;
  action?: ReactNode;
  height?: number | string;
}) {
  return (
    <div
      className="flex flex-col items-center justify-center rounded-md border border-dashed border-edge bg-surface-2/40 p-6 text-center"
      style={{ minHeight: height }}
    >
      <div className="mb-3 grid h-12 w-12 place-items-center rounded-full bg-surface text-text-faint">
        {icon ?? <Inbox size={20} />}
      </div>
      <div className="text-sm font-semibold text-text">{title}</div>
      {detail && <div className="mt-1 max-w-md text-xs text-text-muted">{detail}</div>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}
